import React from "react";
import { PopularQueriesBlockProps } from "../../types/search";
import "../../styles.css";

/**
 * PopularQueriesBlock - Displays a list of frequently searched queries
 *
 * This component shows a static list of popular queries with optional counts.
 * No functionality except optional click handlers for future use.
 */
const PopularQueriesBlock: React.FC<PopularQueriesBlockProps> = ({ queries, onQueryClick }) => {
  const handleQueryClick = (query: string) => {
    // Optional callback for future use
    if (onQueryClick) {
      onQueryClick(query);
    }
  };

  return (
    <div className="popular-queries-block">
      <div className="block-header">
        <h3 className="block-title">Часто ищут</h3>
      </div>

      {queries.length > 0 ? (
        <ul className="queries-list">
          {queries
            .filter((item, index) => item.query && index < 6)
            .map((item) => (
              <li key={item.query} className="query-item">
                <button
                  type="button"
                  className="query-button"
                  onClick={() => handleQueryClick(item.query)}
                  aria-label={`Search for ${item.query}`}
                >
                  <img className="fas fa-fire query-icon" src="/src/img/search-md.svg" />
                  <span className="query-text">{item.query}</span>
                  {/* {item.count !== undefined && <span className="query-count">({item.count})</span>} */}
                </button>
              </li>
            ))}
        </ul>
      ) : (
        <p className="empty-message">Нет популярных запросов</p>
      )}
    </div>
  );
};

export default PopularQueriesBlock;
